import { GlobalSearchArticle, GlobalSearchPerson } from '@pu/models';

export const globalSearchFeatureKey = 'Global Search';

export interface GlobalSearchState {
  people: GlobalSearchPerson[];
  news: GlobalSearchArticle[];
  opened: boolean;
}
